// @ts-check
import React, { forwardRef } from "react"
import PropTypes from "prop-types"
import Dropdown from "../atoms/Dropdown.atom"
import { hasAnyErrors } from "../../utils/validations.utils"
import ErrorMessageForm from "../atoms/ErrorMessageForm.atom"
import Label from "../atoms/Label.atom"
import ViewOutputForm from "../atoms/ViewOutputForm.atom"
import {
  clsx,
  formatToHtmlId,
  generateRandomId,
} from "../../utils/strings.utils"

/** @type {import("./DropdownInput.molecule.types").DropdownInput} */
const DropdownInput = forwardRef((props, ref) => {
  const errors = props.errors || []
  const className = props.className || ""
  let forId = null

  if (props.id) {
    forId = props.id
  } else if (props.name && props.label) {
    forId = `dropdown-input-${formatToHtmlId(props.name + props.label)}`
  } else {
    forId = `dropdown-input-${generateRandomId()}`
  }

  let value = props.value ? props.value?.[props.optionLabel] : "-"
  if (!value) {
    value =
      props.options?.find(
        (option) => option[props.optionValue] === props.value
      )?.[props.optionLabel] || "-"
  }
  return (
    <>
      {(props.label || props.optional || props.required) && (
        <Label
          className={props.disabled ? "opacity-40" : ""}
          htmlFor={forId}
          id={forId + "-label"}
        >
          {" "}
          {props.label}
          {props.required ? " *" : ""}
          {props.optional ? " (Opcional)" : ""}
        </Label>
      )}
      {props.viewOnly ?
        <ViewOutputForm value={value} />
      : <Dropdown
          ref={ref}
          inputId={forId}
          {...props}
          emptyMessage={
            props.emptyMessage || "Misión fallida... no encontramos nada"
          }
          className={clsx(
            className,
            hasAnyErrors(errors) ? `p-invalid ${className}` : className
          )}
        />
      }
      {hasAnyErrors(errors) && !props.withoutErrorMessage ?
        <ErrorMessageForm errorMessage={errors[0]?.errorMessage} />
      : null}
    </>
  )
})

DropdownInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  itemTemplate: PropTypes.func,
  valueTemplate: PropTypes.func,
  optionGroupChildren: PropTypes.string,
  placeholder: PropTypes.string,
  emptyMessage: PropTypes.string,
  // @ts-ignore
  errors: PropTypes.arrayOf(
    PropTypes.shape({ errorMessage: PropTypes.string })
  ),
  filter: PropTypes.bool,
  filterMatchMode: PropTypes.string,
  filterTemplate: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  filterBy: PropTypes.string,
  showFilterClear: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  optionDisabled: PropTypes.func,
}

export default DropdownInput
